import ContactSection from "./contact-section";
import type { WebsitePhotos } from '../../types/api/website-photos';

interface ContactHomeProps {
    websitePhotos?: WebsitePhotos | null;
    title?: string;
    subtitle?: string;
}

export const ContactHome = ({
    websitePhotos,
    title = "",
    subtitle = "",
}: ContactHomeProps) => {
    return (
        <ContactSection
            websitePhotos={websitePhotos}
            title={title}
            subtitle={subtitle}
        />
    );
};


